'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

exports.default = getCss;

var _prefixer = require('./prefixer');

var _prefixer2 = _interopRequireDefault(_prefixer);

var _valueToString = require('./value-to-string');

var _valueToString2 = _interopRequireDefault(_valueToString);

var _getClassName = require('./get-class-name');

var _getClassName2 = _interopRequireDefault(_getClassName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Generates the class name and styles.
 */


function getCss(propertyInfo, value) {
  var rules = void 0; // Protect against unexpected values

  var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);

  if (valueType !== 'string' && valueType !== 'number') {
    if (process.env.NODE_ENV !== 'production') {
      var name = propertyInfo.jsName;
      var encodedValue = JSON.stringify(value);
      console.error("\uD83D\uDCE6 ui-box: property \u201C" + name + "\u201D was passed invalid value \u201C" + encodedValue + "\u201D. Only numbers and strings are supported.");
    }

    return null;
  }

  var valueString = (0, _valueToString2.default)(value, propertyInfo.defaultUnit);
  var className = (0, _getClassName2.default)(propertyInfo, valueString); // Avoid running the prefixer when possible because it's slow

  if (propertyInfo.isPrefixed) {
    rules = (0, _prefixer2.default)(propertyInfo.jsName, valueString);
  } else {
    rules = [{
      property: propertyInfo.cssName,
      value: valueString
    }];
  }

  var styles = void 0;

  if (process.env.NODE_ENV === 'production') {
    var rulesString = rules.map(function (rule) {
      return rule.property + ':' + rule.value;
    }).join(';');
    styles = '.' + className + '{' + rulesString + '}';
  } else {
    var _rulesString = rules.map(function (rule) {
      return '  ' + rule.property + ': ' + rule.value + ';';
    }).join('\n');

    styles = '\n.' + className + ' {\n' + _rulesString + '\n}';
  }

  return {
    className: className,
    styles: styles
  };
}